import React, { useEffect, useState } from 'react'
import { LayoutTitle, LayoutView, TitleText } from '../../component/layout/layoutMainStyle'
import NotificationsApi from '../../api/notification/notification.api'
import { Box, Grid, Typography } from '@mui/material'
import ButtonCustom from '../../component/button/buttonCustom'
import moment from 'moment'
import { swalActive, swalError, swalSuccess } from '../../component/notification/swal'

export default function Notification() {
    const [data, setData] = useState<any>([])
    const getNotifications = async () => {
        const res = await NotificationsApi.getNotifications()
        const data = res.data
        if (data.success) {
            setData(data.result.items)
        }
    }
    const deleteNotifications = async (id: number) => {
        swalActive(
            `ยืนยันที่จะลบหรือไม่?`,
            null, (res: any) => {
                if (res) {
                    NotificationsApi.deleteNotifications(id)
                        .then(async (res) => {
                            if (res?.data?.success) {
                                swalSuccess('ลบสำเร็จ')
                                getNotifications()
                            } else {
                                swalError(res.response.data.description || res.response.data.message);
                            }

                        })
                        .catch((error) => {
                            swalError(error.response.data.description || error.response.data.message);
                        })
                }
            })
    }

    useEffect(() => {
        getNotifications()
    }, [])
    return (
        <LayoutView>
            <LayoutTitle>
                <TitleText>แจ้งเตือน</TitleText>
            </LayoutTitle>
            <Grid container spacing={2}>
                {data?.map((item: any, i: number) => {
                    return (
                        <Grid xs={12} sx={{
                            display: "flex", alignItems: "center", padding: '16px', justifyContent: "space-between", boxShadow: '0px 4px 6px -1px rgba(16, 24, 40, 0.10), 0px 2px 4px -2px rgba(16, 24, 40, 0.10)',
                            borderRadius: "8px", background: item?.isRead ? '#f7f7f7': '#ffff', marginBottom:"20px"
                        }}>
                            <Box sx={{ width: "100%" }}>
                                <Box sx={{ display: "flex", alignItems: "center", marginBottom: '10px' }}>
                                    <Typography variant='h5' sx={{ marginRight: "25px" }}>{item?.title}</Typography>
                                    <Typography>{moment(item?.createDate).add('year', 543).format('DD MMM YYYY h:mm:ss a')}</Typography>
                                </Box>
                                <Typography variant='body1'>{item?.description}</Typography>
                            </Box>
                            <ButtonCustom variant='outlined' textButton={'ลบ'} onClick={() => { deleteNotifications(item?.idNotification) }} btnStyle={{
                                width: '80px',
                                '&.MuiButton-outlined': {
                                    marginTop: '12px',
                                    color: `red !important`,
                                    border: `2px solid red !important`,
                                    borderRadius: "10px !important",
                                    '&:hover': {
                                        color: `red  !important`,
                                        border: `2px solid red !important`,
                                        backgroundColor: '#EFFFF7 !important'
                                    },
                                },
                            }} style={{ margin: "auto", width: '80px', }} />
                        </Grid>
                    )
                })}

            </Grid>

        </LayoutView>
    )
}
